import AuthService from './authService.js';

class LevelService {
  static GetLevelById(id) {
    return AuthService.getInstance().CallBackendFunction('/api/Level/GetLevelById/' + id);
  }
}

export default LevelService;
